import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

type TState = {
  filters: TAnyObject;
};

const initialState = (): TState => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.MESSAGE_MATCHER_PRESETS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const messageMatcherPresetsSlice = createSlice({
  name: 'messageMatcherPresets',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = messageMatcherPresetsSlice.actions;

export const selectFilters = (state: TRootState) => state.messageMatcherPresets.filters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(
      EStorageKeys.MESSAGE_MATCHER_PRESETS_FILTERS,
      JSON.stringify(action.payload),
    );
  },
});

export default messageMatcherPresetsSlice.reducer;
